import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M9.308 1v2.625c0 .483.413.875.923.875H13m-8.769 0h1.846M4.231 7.125h5.538M4.231 9.75h5.538m1.846-7.437c-.41-.349-.837-.762-1.106-1.03A.97.97 0 0 0 9.823 1H2.846C1.826 1 1 1.784 1 2.75v10.5c0 .966.827 1.75 1.846 1.75h8.308c1.02 0 1.846-.784 1.846-1.75V3.973a.84.84 0 0 0-.254-.6 26 26 0 0 0-1.13-1.06"
    }, null, -1)
  ])))
}
export default { render: render }